// @flow

import SuggestionsBuilder from './SuggestionsBuilder';

export default class KeywordSuggestions extends SuggestionsBuilder {
  /**
   * @inheritDoc
   */
  static hasValidData(data: any): boolean {
    return Array.isArray(data) && data.length;
  }

  /**
   * @inheritDoc
   */
  template(): string {
    const eventData: string = encodeURIComponent(JSON.stringify({ keywords: this.dataLayerSuggestions.all() }));
    const on = encodeURIComponent(JSON.stringify({ view: 'keyword-impression' }));
    return `
      <span class="block text-xs text-grey px-4 mt-4 mb-2">
        ${window.store.getTranslation('Search suggestions')}
      </span>
      <ul class="mb-0 ml-0">
        ${this.buildSuggestions()}
      </ul>
    `;
  }

  /**
   * @inheritDoc
   */
  suggestion(suggestion: any): string {
    const eventData: string = this.dataLayerSuggestions
      .find((datalayerSuggestion: Object) => datalayerSuggestion.name === suggestion);
    const on = encodeURIComponent(JSON.stringify({ click: 'keyword-click' }));
    return `
      <li>
        <a
          href="/${window.store.getTranslation('search.url')}?query=${suggestion}"
          class="block px-4 py-2 text-black hover:bg-light-grey focus:bg-light-grey"
          ref="suggestion"
        >
          ${suggestion}
        </a>
      </li>
    `;
  }
}
